import {
  GetPaymentLinkLineItemsQuery,
  GetPaymentLinkLineItemsQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const GET_PAYMENT_LINK_LINE_ITEMS_QUERY = gql`
  query GetPaymentLinkLineItems(
    $paymentLinkUUID: uuid!
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getPaymentLinkLineItems(
      payment_link_id: $paymentLinkUUID
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      created_at
      payment_link_url
      total_remaining_balance_in_micros
      credit_memos {
        remaining_balance_in_micros
        credit_memo {
          credit_date
          credit_number
          uuid
        }
      }
      invoices {
        remaining_balance_in_micros
        order_invoice {
          due_at
          invoice_number
          uuid
        }
      }
    }
  }
`;

export const useGetPaymentLinkLineItems = (
  paymentLinkUUID: string,
  restaurantUUID: string,
  supplierUUID: string,
) => {
  return useWrappedQuery<
    GetPaymentLinkLineItemsQuery,
    GetPaymentLinkLineItemsQueryVariables
  >(GET_PAYMENT_LINK_LINE_ITEMS_QUERY, {
    variables: { paymentLinkUUID, restaurantUUID, supplierUUID },
  });
};
